import React, { useEffect, useState } from 'react';
import '../styles/Market.css';
import Loader from '../components/Loader';
const tickers = [
    'AAPL', 'NVDA', 'MSFT', 'GOOGL', 'AMZN', 'TSLA', 'META', 'AMD', 'INTC', 'CRM',
    'ADBE', 'ORCL', 'CSCO', 'SNAP', 'UBER', 'LYFT', 'SHOP', 'ROKU', 'SQ', 'PLTR',
    'NFLX', 'DIS', 'BA', 'KO', 'PEP', 'WMT', 'COST', 'TGT', 'NKE', 'MCD',
    'SBUX', 'WBA', 'HD', 'LOW', 'JNJ', 'PFE', 'MRNA', 'ABBV', 'BMY', 'LLY',
    'UNH', 'CI', 'GS', 'JPM', 'BAC', 'WFC', 'C', 'MS', 'AXP', 'V',
    'MA', 'PYPL', 'SO', 'DUK', 'NEE', 'XOM', 'CVX', 'PSX', 'SLB', 'COP',
    'F', 'GM', 'T', 'TMUS', 'VZ', 'DE', 'IBM', 'HON', 'GE', 'MMM',
    'RTX', 'LMT', 'FDX', 'UPS', 'NOC', 'AAL', 'DAL', 'UAL', 'LUV', 'ZM',
    'DDOG', 'NET', 'CRWD', 'PANW', 'OKTA', 'SNOW', 'ABNB', 'AI', 'COIN', 'HOOD',
    'RIOT', 'MARA', 'GME', 'NVAX', 'BBBY', 'BILI', 'BIDU', 'NIO', 'LI', 'XPEV'
];


function Market() {
    const [marketData, setMarketData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch(`https://stocks.algobook.info/api/v1/stocks?tickers=${tickers.join(',')}`)
            .then(res => res.json())
            .then(data => {
                setMarketData(data);
                setIsLoading(false);
            })
            .catch(err => {
                console.error('Error fetching market data:', err);
                setIsLoading(false);
            });
    }, []);

    const getSortedData = () => {
        if (!marketData || marketData.length === 0) return { gainers: [], losers: [], trending: [] };

        const enriched = marketData.map(stock => {
            const lastPrice = parseFloat(stock.lastPrice);
            const lastClose = parseFloat(stock.lastClose);
            const priceChange = lastPrice - lastClose;
            const percentageChange = (priceChange / lastClose) * 100;

            return {
                ...stock,
                lastPrice: lastPrice.toFixed(2),
                percentageChange: percentageChange.toFixed(2),
                priceChange: priceChange.toFixed(2),
                absChange: Math.abs(priceChange),
            };
        });

        const gainers = enriched
            .filter(stock => stock.percentageChange > 0)
            .sort((a, b) => b.percentageChange - a.percentageChange)
            .slice(0, 8);

        const losers = enriched
            .filter(stock => stock.percentageChange < 0)
            .sort((a, b) => a.percentageChange - b.percentageChange)
            .slice(0, 8);

        const trending = enriched
            .sort((a, b) => b.absChange - a.absChange)
            .slice(0, 8);

        return { gainers, losers, trending };
    };

    const { gainers, losers, trending } = getSortedData();

    return (
        <div className="market-container">
            <h2 className="text-heading centered">Market Movers</h2>

            {isLoading ? (
                <div className="loader-center">
                    <Loader />
                </div>
            ) : (
                <div className="market-boxes">
                    <div className="market-section">
                        <h3 className="section-title">Top Gainers</h3>
                        {gainers.map(stock => (
                            <div key={stock.ticker} className="market-item">
                                <strong>{stock.ticker}</strong>
                                <span>${stock.lastPrice}</span>
                                <span className="positive">{stock.percentageChange}%</span>
                            </div>
                        ))}
                    </div>
                    <div className="market-section">
                        <h3 className="section-title">Top Losers</h3>
                        {losers.map(stock => (
                            <div key={stock.ticker} className="market-item">
                                <strong>{stock.ticker}</strong>
                                <span>${stock.lastPrice}</span>
                                <span className="negative">{stock.percentageChange}%</span>
                            </div>
                        ))}
                    </div>
                    <div className="market-section">
                        <h3 className="section-title">Trending Stocks</h3>
                        {trending.map(stock => (
                            <div key={stock.ticker} className="market-item">
                                <strong>{stock.ticker}</strong>
                                <span>${stock.lastPrice}</span>
                                <span className={stock.percentageChange >= 0 ? 'positive' : 'negative'}>
                                    {stock.priceChange} ({stock.percentageChange}%)
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Market;
